const VUE_APP_API_UPLOAD_URL = document.querySelector("body").getAttribute("api_upload_url");

export default VUE_APP_API_UPLOAD_URL